import React from "react";
import "./tag.css";
import classNames from "classnames";

const Tag = (props) => {
  const { className, children, dangerouslySetInnerHTML } = props;
  return (
    <span
      {...props}
      className={classNames("tagSpan", className)}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    >
      {children}
    </span>
  );
};

export default Tag;
